function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
import { useLazyQuery, useQuery } from "@apollo/client";
import { useFocusEffect } from "@react-navigation/native";
import * as Sentry from "@sentry/core";
import { useCallback, useContext, useMemo, useRef, useState } from "react";
import { graphql } from "@oui/lib/src/graphql/tada";
import { CurrentUserContext } from "../components/CurrentUserContext";
import { Environment, environment } from "../constants";
export * from "./useCurrentUser.query";
// We currently dont allow staff users to store/fetch assets so we can't include this in the CurrentUser query
// avatar: asset(context: "user", key: "avatar")
export var SelfPatientQuery = graphql("\n  query SelfPatient {\n    user {\n      ID\n      role {\n        ID\n        progress {\n          content\n          completion\n          completed\n          updatedAt\n        }\n      }\n    }\n  }\n");
export function useCurrentUser() {
    return useContext(CurrentUserContext);
}
export function useCurrentPatient() {
    var // though the function is called useCurrent"Patient", the term "Patient" used to include all
    // non-staff roles
    _user_user_role, _user_user, _user_user_role1, _user_user1, _user_user_role2, _user_user2;
    var _useCurrentUser = useCurrentUser(), user = _useCurrentUser.data;
    if ((user === null || user === void 0 ? void 0 : (_user_user = user.user) === null || _user_user === void 0 ? void 0 : (_user_user_role = _user_user.role) === null || _user_user_role === void 0 ? void 0 : _user_user_role.roleType) === 'PATIENT' || (user === null || user === void 0 ? void 0 : (_user_user1 = user.user) === null || _user_user1 === void 0 ? void 0 : (_user_user_role1 = _user_user1.role) === null || _user_user_role1 === void 0 ? void 0 : _user_user_role1.roleType) === 'SUPPORTER' || (user === null || user === void 0 ? void 0 : (_user_user2 = user.user) === null || _user_user2 === void 0 ? void 0 : (_user_user_role2 = _user_user2.role) === null || _user_user_role2 === void 0 ? void 0 : _user_user_role2.roleType) === 'GUARDIAN') {
        return user.user.role;
    }
    return null;
}
export function useCurrentPatientID() {
    var role = useCurrentPatient();
    var _role_ID;
    return (_role_ID = role === null || role === void 0 ? void 0 : role.ID) !== null && _role_ID !== void 0 ? _role_ID : null;
}
export function useProgress() {
    return useQuery(SelfPatientQuery);
}
export function useProgressFetcher() {
    var _useLazyQuery = _sliced_to_array(useLazyQuery(SelfPatientQuery, {
        fetchPolicy: 'network-only'
    }), 1), fetch = _useLazyQuery[0];
    return fetch;
}
export function useProgressByContent() {
    var _useProgress = useProgress(), data = _useProgress.data, rest = _object_without_properties(_useProgress, [
        "data"
    ]);
    var progress = useMemo(function() {
        var _data_user_role, _data_user;
        var _data_user_role_progress;
        var items = (_data_user_role_progress = data === null || data === void 0 ? void 0 : (_data_user = data.user) === null || _data_user === void 0 ? void 0 : (_data_user_role = _data_user.role) === null || _data_user_role === void 0 ? void 0 : _data_user_role.progress) !== null && _data_user_role_progress !== void 0 ? _data_user_role_progress : [];
        return items.reduce(function(carry, p) {
            carry[p.content] = p;
            return carry;
        }, {});
    }, [
        data
    ]);
    return _object_spread({
        data: progress
    }, rest);
}
export function useProgressComplete(contentName) {
    var completeOrNotComplete = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true;
    var _data_user_role, _data_user, _data_user_role1, _data_user1;
    var _useState = _sliced_to_array(useState(false), 2), stale = _useState[0], setStale = _useState[1];
    var staleRef = useRef(stale);
    staleRef.current = stale;
    var _useProgress = useProgress(), refetch = _useProgress.refetch, data = _useProgress.data;
    var progressEntry = data === null || data === void 0 ? void 0 : (_data_user = data.user) === null || _data_user === void 0 ? void 0 : (_data_user_role = _data_user.role) === null || _data_user_role === void 0 ? void 0 : _data_user_role.progress.find(function(e) {
        return e.content === contentName;
    });
    var completeResult = !completeOrNotComplete && !progressEntry || (progressEntry === null || progressEntry === void 0 ? void 0 : progressEntry.completed) === completeOrNotComplete;
    var completeResultRef = useRef(completeResult);
    completeResultRef.current = completeResult;
    useFocusEffect(useCallback(function() {
        if (completeResultRef.current !== true) {
            if (staleRef.current) {
                try {
                    refetch === null || refetch === void 0 ? void 0 : refetch().then(function() {
                        setStale(false);
                    }).catch(function(e) {
                        setStale(false);
                    });
                } catch (e) {
                    if (environment !== Environment.DEVELOPMENT) {
                        Sentry.captureException(e);
                    }
                }
            }
            return function() {
                // if completeResult is already in it's target end state, we dont need to worry about
                // marking as stale to refetch later.
                setStale(!completeResultRef.current);
            };
        }
        return;
    }, [
        refetch
    ]));
    return stale ? {
        completeResult: false,
        maybeCompleteResult: false,
        loaded: false,
        refetch: refetch
    } : {
        completeResult: completeResult,
        maybeCompleteResult: progressEntry ? progressEntry.completed === completeOrNotComplete : undefined,
        refetch: refetch,
        loaded: !!(data === null || data === void 0 ? void 0 : (_data_user1 = data.user) === null || _data_user1 === void 0 ? void 0 : (_data_user_role1 = _data_user1.role) === null || _data_user_role1 === void 0 ? void 0 : _data_user_role1.progress)
    };
}
